import {PageHeader} from "../../../components/exports";
import {
    Accordion,
    AccordionDetails, AccordionProps,
    AccordionSummary,
    Icon,
    ListItemProps, Stack,
    styled,
    Typography, TypographyProps
} from "@mui/material";

const BlogAccordion = styled((props: AccordionProps) => <Accordion defaultExpanded {...props}/>)(({theme}) => ({
    '&.Mui-expanded': {
        margin: '4px',
    },
}))

const BlogAccordionSummary = styled((props: ListItemProps) => {
    return <Typography {...props} fontSize="medium" fontWeight="bold" color='primary'/>
})({})

const BlogHighLight = styled((props: TypographyProps) =>
    <Typography fontWeight='bold' component="span" color="primary" {...props} />)({})

export default function Blog() {
    return (
        <>
            {/*<PageHeader title="شفاف و روشن: سرویس پیامک پرشین سازه به هزینه‌اش میارزد؛ چرا؟"/>*/}

            <Typography sx={{textAlign: 'justify', marginBottom: 1}}>
                ممکن است برایتان این سوال پیش آمده باشد که تفاوت کیفیت و قیمت سرویس پیامک پلتفرم ما با بعضی از
                سرویس‌های دیگر چیست. یک پاسخ ساده به این پرسش، <BlogHighLight>«اصل خلق ارزش افزوده»</BlogHighLight> است؛
                به این معنی که ما فقط سرویس
                پیامک ارائه نمی‌کنیم، بلکه روی آن ارزش‌های دیگری اضافه کرده و به شما تحویل می‌دهیم تا راحت‌تر و بهتر به
                هدف‌تان برسید.
            </Typography>

            <Typography sx={{textAlign: 'justify', fontSize: 'medium', marginBottom: 1}} component='h2'>
                ارزش افزوده سرویس پیامک پرشین سازه
            </Typography>

            <Stack direction='column' spacing='4px'>
                <BlogAccordion>
                    <AccordionSummary
                        expandIcon={<Icon>expand_more</Icon>}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <BlogAccordionSummary>
                            ۱ - ارسال پیامک هدفمند، مختص صنعت ساختمان
                        </BlogAccordionSummary>
                    </AccordionSummary>
                    <AccordionDetails sx={{textAlign: 'justify'}}>
                        ارسال پرت، کور و بی‌هدف نه تنها برای شما سودی ندارد،
                        بلکه فقط هزینه‌ی بیجاست. شما بایستی به سازندگانی پیامک ارسال کنید که در مرحله‌ی مناسب برای
                        خرید محصول شما قرار دارند. به عنوان مثال اگر شما هر روز تعدادی از شماره‌ها را در پنل خود ثبت
                        کنید، بعد از مدتی تعداد زیادی مخاطب/پروژه خواهید داشت که نمی‌دانید در چه مرحله‌ای هستند و در
                        نتیجه نیاز دارید تا بتوانید در پنل پیامکی، فیلتربندی کرده و برای مخاطبان هدف‌تان پیامک را
                        ارسال کنید. این یکی از ارزش‌های افزوده‌ایست که ما در پنل پیامکی پرشین سازه ارائه می‌کنیم تا
                        هدفمند و کم هزینه تبلیغات خود را پیش ببرید.
                    </AccordionDetails>
                </BlogAccordion>

                <BlogAccordion>
                    <AccordionSummary
                        expandIcon={<Icon>expand_more</Icon>}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <BlogAccordionSummary>
                            ۲ - اطمینان از رسیدن پیامک به مخاطب
                        </BlogAccordionSummary>
                    </AccordionSummary>
                    <AccordionDetails sx={{textAlign: 'justify'}}>
                        سرویس پیامکی ما چند سرشماره‌ی خدماتی دارد تا مطمئن باشیم که پیامک شما به مخاطب مقصد می‌رسد.
                        استفاده از سرشماره‌ی خدماتی که قابلیت عبور از بلک لیست مخابرات را دارد، بدون درج عبارت «لغو
                        11» که در سرشماره‌های دیگر اجباری است، دریافت پیامک شما توسط سازندگان را تضمین می‌کند و به
                        شکل چشمگیری باعث افزایش بازدهی استفاده از سرویس پیامکی می‌شود.
                    </AccordionDetails>
                </BlogAccordion>

                <BlogAccordion>
                    <AccordionSummary
                        expandIcon={<Icon>expand_more</Icon>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <BlogAccordionSummary>
                            ۳ - احتمال بالای باز شدن و خواندن پیامک توسط سازنده
                        </BlogAccordionSummary>
                    </AccordionSummary>
                    <AccordionDetails sx={{textAlign: 'justify'}}>
                        بر مبنای نتایج تحقیقات میدانی، به دلیل استفاده‌ی طولانی مدت از سرشماره‌های اختصاصی پرشین
                        سازه در صنعت ساختمان و عدم‌استفاده در صنایع دیگر، این سرشماره‌ها برای بسیاری از سازندگان حکم
                        مرجع را پیدا کرده‌اند و بسیاری از آنان نه تنها پیامک‌های این سرشماره را باز کرده و می‌خوانند،
                        بلکه بسیاری از آنان حتی پیامک‌ها را نگه می‌دارند تا در زمان مناسب بتوانند با تامین
                        کنندگانی که پیامک را ارسال کرده‌اند، به سادگی ارتباط بگیرند؛ چرا که می‌دانند تمامی پیامک‌های
                        ارسالی از این سرشماره‌ها مختص صنعت ساختمان و شغل ایشان هستند، بنابراین احتمال نخوانده پاک
                        شدن پیامک‌های این سرشماره‌ها بسیار پایین‌تر از سایر سرشماره‌ها است.
                    </AccordionDetails>
                </BlogAccordion>
                <BlogAccordion>
                    <AccordionSummary
                        expandIcon={<Icon>expand_more</Icon>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <BlogAccordionSummary>
                            ۴ - استفاده از بهترین زیرساخت‌های ارسال؛ قابل مقایسه با سرویس‌های بانکی
                        </BlogAccordionSummary>
                    </AccordionSummary>
                    <AccordionDetails sx={{textAlign: 'justify'}}>
                        سرویس پیامک پرشین سازه، اختصاصی طراحی و اجرا شده است و از نظر کیفیت، دقت و امنیت قابل مقایسه با
                        سرویس‌های بانکی است که بایستی حتما استانداردهای بسیار بالایی داشته باشند. هزینه‌های ماهانه
                        تامین و
                        نگهداشت زیرساخت‌های ارسال پیامک، از جمله سرویس‌ها، سیستم‌ها، سرورها و … تفاوت چشمگیری در سرعت
                        ارسال،
                        اطمینان از قطعی شدن ارسال، و البته قیمت تمام شده‌ی نهایی هر پیامک دارند. هرچه زیرساخت بهتر، سرعت
                        و
                        دقت ارسال و دقت گزارشات بیشتر که به نوبه‌ی خود تاثیر چشمگیری بر بازدهی نهایی سرویس پیامک برای
                        مصرف
                        کننده دارد.
                    </AccordionDetails>
                </BlogAccordion>
                <BlogAccordion>
                    <AccordionSummary
                        expandIcon={<Icon>expand_more</Icon>}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <BlogAccordionSummary>
                            ۵ - درستی ۱۰۰٪ گزارش‌ها
                        </BlogAccordionSummary>
                    </AccordionSummary>
                    <AccordionDetails sx={{textAlign: 'justify'}}>
                        اگر ۱۰.۰۰۰ پیامک از سرویس ما ارسال کنید می‌توانید تا آخرین عدد آن را پیگیری کنید و از رسیدن یا
                        نرسیدن پیامک به مقصد مطمئن شوید. این طور نیست که ۱۰.۰۰۰ ارسال داشته باشید و به خاطر سودآوری
                        بیشتر
                        ۱.۰۰۰ عدد از آن اصلا ارسال نشود و شما به دروغ گزارش دلیور شد دریافت کنید. آزمایش این موضوع بسیار
                        ساده است. بنابراین در بسیاری از مواقع قیمت‌های کم حکم کم‌ارسالی را هم دارند.
                    </AccordionDetails>
                </BlogAccordion>
            </Stack>

            <Typography sx={{textAlign: 'justify', paddingBottom: 4, marginTop: 3}}>
                مجموع عواملی که بیان شد، ارزش‌های افزوده‌ای هستند که ما در پرشین سازه با وسواس و دقت بر روی
                سرویس
                پیامکی‌مان پیاده کرده‌ایم تا شما با هزینه‌ای معقول، ارزشی سودمند و برابر و حتی بیشتر نصیب‌تان
                شود و
                خیال‌تان راحت باشد که پیام‌تان به درستی و کامل به مخاطب مقصد می‌رسد.
                از قدیم هم گفته‌اند، به جای آن که بارها و چند هزینه‌ی به ظاهر کم بکنید، یک بار هزینه‌ی درستی
                کنید و
                نتیجه‌ی بهتری بگیرید.
            </Typography>
        </>
    )
}
